import React from "react";
import StickyNavbar from "../navbar";
import { Link } from "react-router-dom";
import * as motion from "motion/react-client";
const ChapterTwoPrinciples = () => {
  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };
  return (
    <div>
      <StickyNavbar />
      
      <motion.div
        className="bg-white text-black p-4 lg:mt-10 mt-20 sm:p-10 lg:px-20 text-lg"
        initial="hidden"
        animate="visible"
        variants={staggerContainer}
      >
        <div className="space-y-3">
          <h2 className="text-xl font-bold mb-2 text-[#005FFF] text-center">
            Principles of research ethics
          </h2>
          <motion.div
        className="mt-6 flex items-center justify-center m-auto"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8 }}
      >
        <iframe
          width="65%"
          height="630"
          src="https://res.cloudinary.com/dk56u1huz/video/upload/v1740874576/Chapter_2_Part_2_RESEARCH_ETHICS_1_cw2ci5.mp4"
          title="Introduction to Research"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="rounded-lg"
        ></iframe>
      </motion.div>
          <p>
            Below is a list of important things we must think about when doing
            research, that have been put together from ethical codes like the
            Nuremberg Code, Declaration of Helsinki, the Belmont Report, and
            Nigeria’s National Code of Research Ethics (56-59). Which ethical
            guidelines or codes researchers follow depends on where they work
            and who they work with, however, they all share common ideas. They
            are there to help researchers carry out work responsibly and protect
            the rights and safety of participants.
          </p>
          <ul className="list-disc list-inside space-y-3">
            <li>
              <b className="text-green-700">Social and clinical value:</b>{" "}
              Research should aim to answer important questions that hold value,
              in other words, there should be a good reason for doing the
              research. This helps to justify any risks participants face, as
              what we learn is helping to better our understanding of health
              treatments or care.
            </li>
            <li>
              <b className="text-green-700">Scientific validity:</b> Studies
              must be put together carefully so that they give reliable,
              meaningful results. If research is poorly planned, then what we
              find cannot be relied upon and is unlikely to be trusted by
              others. If what we find cannot be used, this means participants'
              time and safety were put at risk without any real benefit.
            </li>
            <li>
              <b className="text-green-700">Selecting participants fairly:</b>{" "}
              You should select people to be participants in your study based on
              the goals of the research, making sure that no group is unfairly
              left out or taken advantage of in the research process.
            </li>
            <li>
              <b className="text-green-700">Risk vs benefit:</b> Researchers
              should try to keep risks as low as possible and make sure that any
              benefits outweigh the harm participants might face in the study.
            </li>
            <li>
              <b className="text-green-700">Informed consent:</b> Participants
              must have clear information about the study, including its
              purpose, the way the research will be carried out, any risks, and
              any benefits. This allows them to make an informed choice on their
              own about where or not to take part. This consent must be recorded
              in some way, and is usually either written (such as a signature)
              or orally given.
            </li>
            <li>
              <b className="text-green-700">Respect for participants:</b> All
              individuals involved in research deserve respect, including
              protection of their privacy, and the right to remove themselves
              from the research at any time.
            </li>
            <li>
              <b className="text-green-700">Accountability:</b> Researchers
              should take responsibility for their actions and the choices that
              they make during the research, and properly deal with any ethical
              problems that may come up.
            </li>
            <li>
              <b className="text-green-700">Confidentiality:</b> Researchers
              must protect participants' privacy by keeping personal information
              they have about participants private. This means using their
              information only for the reasons agreed to when participants gave
              their consent.
            </li>
          </ul>
        </div>
        <div className="flex justify-between mt-10">
          <motion.div
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            transition={{ duration: 0.2 }}
          >
            <Link to="/chapter2">
              <button className="bg-blue-900 text-white px-6 py-2 rounded-lg hover:bg-blue-700">
                Previous
              </button>
            </Link>
          </motion.div>
          <motion.div
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            transition={{ duration: 0.2 }}
          >
            <Link to="/chapter2/sectionOne">
              <button className="bg-blue-900 text-white px-6 py-2 rounded-lg hover:bg-blue-700">
                Next
              </button>
            </Link>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default ChapterTwoPrinciples;
